import { render, staticRenderFns } from "./LoadSpinner.vue?vue&type=template&id=2e9dc0a8&scoped=true&lang=pug&"
var script = {}
import style0 from "./LoadSpinner.vue?vue&type=style&index=0&id=2e9dc0a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9dc0a8",
  null
  
)

export default component.exports